import { Box, Group, Image, Text, useMantineTheme } from "@mantine/core";
import { MdOutlineImage } from "react-icons/md";
import { GetMeetingQuery } from "src/generated/graphql";

type IForm = {
  meetingDetail: GetMeetingQuery["meetingOne"];
};

const DisplayDetail = (name: string, text: string) => {
  return (
    <Group position="apart" m={"xs"}>
      <Text fw={600} fz="sm">
        {name}:
      </Text>
      <Text fw={400} fz="sm">
        {text}
      </Text>
    </Group>
  );
};

export default function MeetingDetail({ meetingDetail }: IForm) {
  const theme = useMantineTheme();
  return (
    <>
      <Group position="apart" sx={{ alignItems: "initial" }}>
        <Box
          sx={{
            width: "25%",
            background: theme.colors.light[1],
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
          }}
          h={90}
          w={90}
        >
          {meetingDetail?.imgUrl ? (
            <Image
              display={"flex"}
              style={{
                alignItems: "center",
              }}
              h={60}
              w={60}
              radius={"xl"}
              src={meetingDetail.imgUrl || ""}
              alt={`${meetingDetail?.name} image`}
            />
          ) : (
            <MdOutlineImage size={60} />
          )}
        </Box>

        {meetingDetail && (
          <Box sx={{ width: "70%" }}>
            {DisplayDetail("Name", meetingDetail.name)}
            {meetingDetail.description &&
              DisplayDetail("Description", meetingDetail.description)}

            {meetingDetail.service &&
              DisplayDetail(
                "Service",
                meetingDetail.service.organizationService.name
              )}

            {meetingDetail.session &&
              DisplayDetail(
                "Private Session",
                `${meetingDetail.session.name} - ${meetingDetail.privateSession?.duration}`
              )}
            {meetingDetail.instructor &&
              DisplayDetail(
                "Instructor",
                meetingDetail.instructor.user.firstName
              )}
            {meetingDetail.room &&
              DisplayDetail("Room", meetingDetail.room.name)}
          </Box>
        )}
      </Group>
    </>
  );
}
